<template>
    <div class="com-site">
        <!-- 导航 -->
        <site-nav @scroll="scrollTop"></site-nav>
        <!-- banner-->
        <site-banner @scroll="scrollTop"></site-banner>
        <!-- 面临问题-->
        <div id="problem">
            <site-problem></site-problem>
        </div>
        <!-- 系统优势 -->
        <div id="advantage">
            <site-advantage></site-advantage>
        </div>
        <!-- 系统特点 -->
        <div id="feature">
            <site-feature></site-feature>
        </div>
        <!-- 合作流程 -->
        <div id="process">
            <site-process></site-process>
        </div>
        <!-- 合作伙伴 -->
        <div id="partner">
            <site-partner></site-partner>
        </div>
        <!-- 联系我们 -->
        <div id="contact">
            <site-contact></site-contact>
        </div>
        <div class="com-footer">
            <div>@ WWW.CXYUNS.COM All Rights Reserved</div>
            <div class="beian">
                <img src="@/assets/beian.png" width="16" />
                <a href="https://beian.miit.gov.cn/" target="_blank">闽ICP备18027535号-3</a>
            </div>
        </div>
        <div class="com-footer__btn block">
            <!-- <span><a href="/merchant/apply?s=0">联系我们</a></span> -->
            <span class="t"><a href="tel:01213188285">拨打电话</a></span>
        </div>
    </div>
</template>

<script>
import SiteNav from './components/nav'
import SiteBanner from './components/banner'
import SiteProblem from './components/problem'
import SiteAdvantage from './components/advantage'
import SiteFeature from './components/feature'
import SiteProcess from './components/process'
import SitePartner from './components/partner'
import SiteContact from './components/contact'

export default {
    name: 'home',
    components: {
        SiteNav,
        SiteBanner,
        SiteProblem,
        SiteAdvantage,
        SiteFeature,
        SiteProcess,
        SitePartner,
        SiteContact
    },

    methods: {
        scrollTop(name) {
            const target = document.getElementById(name)
            window.document.documentElement.scrollTop = window.document.body.scrollTop = target.offsetTop - 40;
        }
    }
}
</script>

<style lang="less">
    .com-site {
        .com-problem, .com-advantage, .com-process, .com-partner, .com-contact {
            padding-top: .6rem;
            padding-bottom: 1.2rem;
        }
        .com-footer {
            text-align: center;
            padding: .4rem 0;
            font-size: .25rem;
            background: #071E5C;
            color: #fff;
            &__btn {
                display: none;
            }

            .beian {
                padding-top: .15rem;
                font-size: .25rem;

                img {
                    margin-right: 5px;
                    vertical-align: middle;
                }

                a {
                    display: inline-block;
                    vertical-align: middle;
                    color: #fff;
                }
            }
        }
    }

    @media only screen and (max-width: 800px) {
        .com-site {
            .com-problem {
                padding-bottom: 5.2rem;
            }
            .com-footer {
                padding-bottom: 1.5rem;
                &__btn {
                    display: block;
                    background: #fff;
                    position: fixed;
                    z-index: 3;
                    bottom: 0;
                    text-align: center;
                    box-shadow: 0 0 0.1rem #cad1e2;
                    span {
                        display: block;
                        // width: 50%;
                        line-height: 1.2rem;
                        // float: left;
                        &.t {
                            position: relative;
                            &::before {
                                display: inline-block;
                                width: 1px;
                                height: 100%;
                                position: absolute;
                                left: 0;
                                background: #eee;
                                content: '';
                            }
                            a {
                                background-image: url('~@/assets/bb.png');
                            }
                        }
                    }
                    a {
                        color: #071E5C;
                        display: inline-block;
                        background: url('~@/assets/ba.png') no-repeat left center;
                        background-size: .57rem;
                        padding-left: .9rem;
                        font-size: .37rem;
                        text-decoration: none;
                    }
                }
            }
        }
    }
</style>


